import { createStore } from 'vuex';
import { api } from "../utils/fetch.js";
import { getQueryString, getTextView } from '@/utils/tools.js';

const store = createStore({
  state () {
    return {
      formConfig: {},
      formItems: [],
      submitDetail: {
        id: null,
        result_type: '',
        result_param: '',
        data: {}
      },
      submitOptionRes: {}
    }
  },
  mutations: {
    ['SET_FORM_CONFIG'] (state, data) {
      state.formConfig = data;
    },
    ['SET_FORM_FIELDS'] (state, data) {
      state.formItems = data?.fields || [];
    },
    ['SET_TOKEN'] (state, token) {
      state.token = token;
      localStorage.setItem('FORM_TOKEN', token);
    },
    ['SET_SUBMIT_DETAIL'] (state, data) {
      state.submitDetail = data;
    },
    ['SET_SUBMIT_OPTION_RES'] (state, data) {
      state.submitOptionRes = data;
    },
  },
  getters: {

  },
  actions: {
    async countFormSubmit({ commit, state }, data) {
      const submitOptionRes = {};
      for (let itemId in data) {
        const index = state.formItems.findIndex(v => v.id === itemId);
        if (
          index >= 0
          && ['select', 'multi_select'].indexOf(state.formItems[index].type) >= 0
        ) {
          submitOptionRes[itemId] = {
            total: 0
          };
          let total = 0;
          for (let i = 0; i < state.formItems[index]?.option?.length; i ++) {
            const submitForm = {
              id: getQueryString('form_id'),
              search_fields: {
                [`${itemId}.value`]: {
                  "operator": "contain",
                  "value": state.formItems[index]?.option[i].id
                }
              }
            };
            let count = 0;
            try {
              if (getQueryString('mode') === 'preview') {
                count = 1;
                total += 1;
              } else {
                await api.CountFormSubmitField(submitForm).then((res) => {
                  count = res.total;
                  total += res.total;
                }).catch((e) => {
                  count = 0;
                });
              }
              
            } catch (error) {
              
            }
            submitOptionRes[itemId] = {
              ...submitOptionRes[itemId],
              [state.formItems[index]?.option[i].id]: count
            };
          }
          submitOptionRes[itemId].total = total;
        }
      }
      commit('SET_SUBMIT_OPTION_RES', submitOptionRes);
    },
    getFormConfig({ commit }, query) {
      return api.GetFormConfig(query).then((res) => {
        commit('SET_FORM_CONFIG', res);
      }).catch((e) => {
        
      });
    },
    getFormFields({ commit }, query) {
      return api.GetFormFields(query).then((res) => {
        commit('SET_FORM_FIELDS', res);
      }).catch((e) => {
        
      });
    },
    getPreviewFormDetail({ commit }, query) {
      return api.GetPreviewFormDetail(query).then((res) => {
        commit('SET_FORM_CONFIG', res);
        commit('SET_FORM_FIELDS', res);
      }).catch((e) => {
        
      });
    },
    getSubmitDetail({ commit }, query) {
      return api.GetSubmitDetail(query, true).then((res) => {
        commit('SET_SUBMIT_DETAIL', res);
      }).catch((e) => {
        throw e;
      });
    },
    // 微信jssdk
    wxJsInit({ dispatch }, isShow) {
      const url = window.location.href;
      const body = {
        url: url,
      };
      const wx = window.wx;
      return api.WxJsSign(body).then((res) => {
        const data = res.data;
        wx.config({
          debug: !!getQueryString('isDebug'),
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: "" + data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: [
            'showMenuItems',
            'hideMenuItems',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'closeWindow',
            'getLocation',
            'chooseImage',
            'previewImage',
            'uploadImage',
            // 'downloadImage'
          ], // 必填，需要使用的JS接口列表
          openTagList: [
            'wx-open-launch-weapp'
          ]
        });
        wx.ready(function () {
          dispatch('setMenu', isShow);
        });
      }).catch((e) => {
        
      });
    },
    setMenu({ dispatch }, isShow) {
      const wx = window.wx;
      if (isShow) {
        wx.showMenuItems({
          menuList: [
            "menuItem:share:timeline",
            "menuItem:share:appMessage"
          ]
        });
        // 设置分享内容
        setTimeout(() => {
          dispatch('setWxShare');
        }, 100);
      } else {
        wx.hideMenuItems({
          menuList: [
            "menuItem:share:timeline",
            "menuItem:share:appMessage"
          ]
        });
      }
    },
    setWxShare({ dispatch, state }) {
      let shareUrl = `${window.location.origin}/addon/app-commonapply/index?form_id=${getQueryString('form_id')}`;
      if (getQueryString('channel_id')) {
        shareUrl = `${shareUrl}&channel_id=${getQueryString('channel_id')}`;
      }
      const sharePic = state.formConfig.cover;
      const shareTitle = state.formConfig.title;
      const introText = getTextView(state.formConfig.intro);
      const shareDesc = introText?.length >= 30 ? introText.slice(0, 27)+ '...' : introText;
      const wx = window.wx;
      console.log({ 
        title: shareTitle,
        desc: shareDesc,
        link: shareUrl,
        imgUrl: sharePic
      });
      wx.updateAppMessageShareData({ 
        title: shareTitle,
        desc: shareDesc,
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: sharePic, // 分享图标
        success: () => {
          console.log('设置成功：updateAppMessageShareData');
        },
        fail: () => {
          console.log('设置失败：updateAppMessageShareData');
        },
      })

      wx.updateTimelineShareData({ 
        title: shareTitle, // 分享标题
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: sharePic,
        success: () => {
          console.log('设置成功：updateTimelineShareData');
        },
        fail: () => {
          console.log('设置失败：updateTimelineShareData');
        }
      })
    },
  }
});
export default store;